import { dataType, dataType as types } from '../../constants/data-type';
import { colorBindingTypes as colorTypes, colorValue } from '../../constants/color-binding-type';
import { IPO_STATUS } from '../../constants/ipo-status';
import { formatFunctions } from './formatFunction';
import { utilsFunction } from '@/helpers/functions'
import { store } from '@/configurations'
import { getSafe } from '../global';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';

export const Converter = {
	mapTradeAccountToOption,
	mapIPOListedFocusData,
	mapAllotmentData,
	mapApplyData,
	mapMarginApplyData,
	mapCAReply,
	mapAssetAllocation,
	mapAccountPL,
	colorMapping,
	mapAccountAsset,
	mappingWebSocketMarket,
	computeQuoteData,
	mappingWebSocketLanguage,
	mappingWinVestLanguage,
	mappingMDSMarketToStock,
	mappingStockCode,
	mappingStatement,
	mapModifyIpoData,
	mappingWinVestChartLanguage,
	numericalTransformation,
	mappingMDSMarketToStock_SH
}

function mapTradeAccountToOption(rawTradeData) {
	let resultData = rawTradeData.map(traceAccount => {
		if (iTradeEnv?.helpers?.functions?.accountToOption) {
			return {
				...traceAccount,
				id: traceAccount.userID,
				value: traceAccount.clientID,
				label: traceAccount.clientID
			}
		}
		return {
			...traceAccount,
			id: traceAccount.userID,
			value: traceAccount.tradingAccSeq,
			label: traceAccount.tradingAccountID || traceAccount.clientID
		}
	});
	return resultData;
}

function mapIPOListedFocusData(rawListedData) {
	let resultData = [];
	if (rawListedData && rawListedData.length > 0) {
		resultData = rawListedData.map(item => {
			let customSymbol = '', customOfferPrice = '';

			customSymbol = `${item.marketID}.${item.instrumentID}`;
			if (item.minOfferPrice && item.maxOfferPrice)
				customOfferPrice = `${item.minOfferPrice} ~ ${item.maxOfferPrice}`;

			return {
				...item,
				customSymbol: customSymbol,
				customOfferPrice: customOfferPrice
			}
		});
	}
	return resultData;
}

function mapAllotmentData(rawData, useIpoAppliedDetailsEnquiryAPI, isMobile = false) {
	let allotment = [];
	let totalAmt = 0, status = '';
	let customSymbol = '-', customOfferPrice = '-', stockName = '-';
	let language = store.getState().app.language;
	if (language.lang === 'en_US') {
		stockName = rawData.instrumentName
	} else {
		if (rawData.instrumentChineseName) {
			stockName = rawData.instrumentChineseName
		} else {
			stockName = rawData.instrumentName
		}
	}
	if (rawData.marketID && rawData.instrumentID && rawData.instrumentName) {
		customSymbol = `${rawData.marketID}.${rawData.instrumentID} ${stockName}`;
	}

	if (rawData.minOfferPrice && rawData.maxOfferPrice) {
		customOfferPrice = `${formatFunctions.dataFormat(rawData.minOfferPrice, types.CURRENCY)} - ${formatFunctions.dataFormat(rawData.maxOfferPrice, types.CURRENCY)}`;
	}
	if (rawData.status) {
		switch (rawData.status) {
			case IPO_STATUS.OPEN: status = getSafe(() => language.ipo_status_open); break;
			case IPO_STATUS.CONFIRMED_F: status = getSafe(() => language.ipo_status_confirmed); break;
			case IPO_STATUS.CLOSED: status = getSafe(() => language.ipo_status_closed); break;
			case IPO_STATUS.CONFIRMED_D: status = getSafe(() => language.ipo_status_confirmed); break;
			case IPO_STATUS.ACCEPTED_H: status = getSafe(() => language.ipo_status_accepted); break;
			case IPO_STATUS.ACCEPTED_I: status = getSafe(() => language.ipo_status_accepted); break;
			case IPO_STATUS.ACCEPTED_W: status = getSafe(() => language.ipo_status_accepted); break;
			case IPO_STATUS.CANCELLED: status = getSafe(() => language.ipo_status_cancelled); break;
		}

	}
	if (useIpoAppliedDetailsEnquiryAPI) {
		let marginFinancingType = '', financingPlanType = '';
		if (rawData.marginFinancingType) {
			switch (rawData.marginFinancingType) {
				case 'O': marginFinancingType = getSafe(() => language.ipo_own_lending); break;
				case 'E': marginFinancingType = getSafe(() => language.ipo_external_lending); break;
				case 'Z': marginFinancingType = getSafe(() => language.ipo_zero_lending); break;
			}
		}
		if (rawData.financingPlanType) {
			switch (rawData.financingPlanType) {
				case 'F': financingPlanType = getSafe(() => language.ipo_fixed_Plan); break;
				case 'I': financingPlanType = getSafe(() => language.ipo_interest_plan); break;
			}
		}
		if (isMobile) {
			allotment = [
				{ label: 'common_reference_no', value: rawData.subscriptionID ? rawData.subscriptionID : '-' },
				{ label: 'ipo_event_status', value: rawData.status ? status : '-' },
				{ label: 'common_symbol_name', value: customSymbol },
				{ label: 'common_listingDate', value: rawData.listingDate },
				{ label: 'common_offer_price', value: customOfferPrice },
				{ label: 'common_currency', value: rawData.currencyID ? rawData.currencyID : '-' },
				{ label: 'application_date', value: rawData.inputDate ? rawData.inputDate : '-' },
				{ label: 'applied_qty', value: rawData.appliedQty ? formatFunctions.dataFormat(rawData.appliedQty, types.NUMBER) : '-' },
				{ label: 'margin_financing_type', value: rawData.marginFinancingType ? marginFinancingType : '-' },
				{ label: 'financing_plan_type', value: rawData.financingPlanType ? financingPlanType : '-' },
				{ label: 'lending_percentage', value: rawData.lendingPercentage ? formatFunctions.dataFormat(rawData.lendingPercentage, types.NUMBER) : '-' },
				{ label: 'applied_consideration', value: rawData.appliedConsideration ? formatFunctions.dataFormat(rawData.appliedConsideration, types.CASH) : '-' },
				{ label: 'applied_fee_amount', value: rawData.appliedFeeAmount ? formatFunctions.dataFormat(rawData.appliedFeeAmount, types.CASH) : '-' },
				{ label: 'applied_amount', value: rawData.appliedAmount ? formatFunctions.dataFormat(rawData.appliedAmount, types.CASH) : '-' },
				{ label: 'handling_fee', value: rawData.handlingFee ? formatFunctions.dataFormat(rawData.handlingFee, types.CASH) : '-' },
				{ label: 'financing_fee', value: rawData.financingFee ? formatFunctions.dataFormat(rawData.financingFee, types.CASH) : '-' },
				{ label: 'interest_rate', value: rawData.interestRate ? formatFunctions.dataFormat(rawData.interestRate, types.CASH) : '-' },
				{ label: 'interest_amount', value: rawData.interestAmount ? formatFunctions.dataFormat(rawData.interestAmount, types.CASH) : '-' },
				{ label: 'deposit_amount', value: rawData.depositAmount ? formatFunctions.dataFormat(rawData.depositAmount, types.CASH) : '-' },
				{ label: 'loan_amount', value: rawData.loanAmount ? formatFunctions.dataFormat(rawData.loanAmount, types.CASH) : '-' },
			]
			totalAmt = (rawData.currencyID ? rawData.currencyID : '') + ' ' + formatFunctions.dataFormat(rawData.totalAmount, types.CASH);
		} else {
			allotment = [
				{ label: 'common_symbol_name', value: customSymbol },
				{ label: 'common_offer_price', value: customOfferPrice },
				{ label: 'common_currency', value: rawData.currencyID ? rawData.currencyID : '-' },
				{ label: 'application_date', value: rawData.inputDate ? rawData.inputDate : '-' },
				{ label: 'applied_qty', value: rawData.appliedQty ? formatFunctions.dataFormat(rawData.appliedQty, types.NUMBER) : '-' },
				{ label: 'margin_financing_type', value: rawData.marginFinancingType ? marginFinancingType : '-' },
				{ label: 'financing_plan_type', value: rawData.financingPlanType ? financingPlanType : '-' },
				{ label: 'lending_percentage', value: rawData.lendingPercentage ? formatFunctions.dataFormat(rawData.lendingPercentage, types.NUMBER) : '-' },
				{ label: 'applied_consideration', value: rawData.appliedConsideration ? formatFunctions.dataFormat(rawData.appliedConsideration, types.CASH) : '-' },
				{ label: 'applied_fee_amount', value: rawData.appliedFeeAmount ? formatFunctions.dataFormat(rawData.appliedFeeAmount, types.CASH) : '-' },
				{ label: 'applied_amount', value: rawData.appliedAmount ? formatFunctions.dataFormat(rawData.appliedAmount, types.CASH) : '-' },
				// { label: 'handling_fee', value: rawData.handlingFee ? formatFunctions.dataFormat(rawData.handlingFee, types.CASH) : '-' },
				{ label: 'financing_fee', value: rawData.financingFee ? formatFunctions.dataFormat(rawData.financingFee, types.CASH) : '-' },
				{ label: 'interest_rate', value: rawData.interestRate ? formatFunctions.dataFormat(rawData.interestRate, types.CASH) : '-' },
				{ label: 'interest_amount', value: rawData.interestAmount ? formatFunctions.dataFormat(rawData.interestAmount, types.CASH) : '-' },
				{ label: 'deposit_amount', value: rawData.depositAmount ? formatFunctions.dataFormat(rawData.depositAmount, types.CASH) : '-' },
				{ label: 'loan_amount', value: rawData.loanAmount ? formatFunctions.dataFormat(rawData.loanAmount, types.CASH) : '-' },
				{ label: 'ipo_event_status', value: rawData.status ? status : '-' },
				{ label: 'common_reference_no', value: rawData.subscriptionID ? rawData.subscriptionID : '-' }
			];
		}
		totalAmt = (rawData.currencyID ? rawData.currencyID : '') + ' ' + formatFunctions.dataFormat(rawData.totalAmount, types.CASH);
	} else {
		if (isMobile) {
			allotment = [
				{ label: 'common_reference_no', value: rawData.subscriptionID ? rawData.subscriptionID : '-' },
				{ label: 'ipo_event_status', value: rawData.status ? status : '-' },
				{ label: 'common_symbol_name', value: customSymbol },
				{ label: 'common_listingDate', value: rawData.listingDate ? rawData.listingDate : '-' },
				{ label: 'common_offer_price', value: customOfferPrice ? customOfferPrice : '-' },
				{ label: 'common_currency', value: rawData.currencyID ? rawData.currencyID : '-' },
				{ label: 'application_date', value: rawData.inputDate ? rawData.inputDate : '-' },
				{ label: 'applied_qty', value: rawData.appliedQty ? formatFunctions.dataFormat(rawData.appliedQty, types.NUMBER) : '-' },
				{ label: 'alloted_qty', value: rawData.allotedQty ? formatFunctions.dataFormat(rawData.allotedQty, types.NUMBER) : '-' },
				{ label: 'confirmed_qty', value: rawData.confirmedQty ? formatFunctions.dataFormat(rawData.confirmedQty, types.NUMBER) : '-' },
				{ label: 'confirmed_price', value: rawData.confirmedPrice ? formatFunctions.dataFormat(rawData.confirmedPrice, types.CURRENCY) : '-' },
				{ label: 'confirmed_alloted_date', value: rawData.confirmedAllotmentDate ? rawData.confirmedAllotmentDate : '-' },
				{ label: 'alloted_date', value: rawData.allotedDate ? rawData.allotedDate : '-' },
				{ label: 'applied_consideration', value: rawData.appliedConsideration ? formatFunctions.dataFormat(rawData.appliedConsideration, types.CASH) : '-' },
				{ label: 'applied_fee_amount', value: rawData.appliedFeeAmount ? formatFunctions.dataFormat(rawData.appliedFeeAmount, types.CASH) : '-' },
				{ label: 'allotment_fee', value: rawData.allotmentFee ? formatFunctions.dataFormat(rawData.allotmentFee, types.CASH) : '-' },
				{ label: 'refund_amount', value: rawData.refund ? formatFunctions.dataFormat(rawData.refund, types.CASH) : '-' },
				{ label: 'bank_number', value: rawData.bankacID ? rawData.bankacID : '-' },
			]
			totalAmt = (rawData.currencyID ? rawData.currencyID : '') + ' ' + formatFunctions.dataFormat(rawData.totalAmount, types.CASH);
		} else {
			allotment = [
				{ label: 'common_symbol_name', value: customSymbol },
				{ label: 'common_offer_price', value: customOfferPrice },
				{ label: 'common_currency', value: rawData.currencyID ? rawData.currencyID : '-' },
				{ label: 'application_date', value: rawData.inputDate ? rawData.inputDate : '-' },
				// { label: 'common_reference_no', value: rawData.subscriptionID ? rawData.subscriptionID : '-' },
				// { label: 'common_status', value: rawData.status ? status : '-' },
				{ label: 'applied_qty', value: rawData.appliedQty ? formatFunctions.dataFormat(rawData.appliedQty, types.NUMBER) : '-' },
				{ label: 'alloted_qty', value: rawData.allotedQty ? formatFunctions.dataFormat(rawData.allotedQty, types.NUMBER) : '-' },
				{ label: 'confirmed_qty', value: rawData.confirmedQty ? formatFunctions.dataFormat(rawData.confirmedQty, types.NUMBER) : '-' },
				{ label: 'confirmed_price', value: rawData.confirmedPrice ? formatFunctions.dataFormat(rawData.confirmedPrice, types.CURRENCY) : '-' },
				{ label: 'confirmed_alloted_date', value: rawData.confirmedAllotmentDate ? rawData.confirmedAllotmentDate : '-' },
				{ label: 'alloted_date', value: rawData.allotedDate ? rawData.allotedDate : '-' },
				{ label: 'applied_consideration', value: rawData.appliedConsideration ? formatFunctions.dataFormat(rawData.appliedConsideration, types.CASH) : '-' },
				{ label: 'applied_fee_amount', value: rawData.appliedFeeAmount ? formatFunctions.dataFormat(rawData.appliedFeeAmount, types.CASH) : '-' },
				{ label: 'allotment_fee', value: rawData.allotmentFee ? formatFunctions.dataFormat(rawData.allotmentFee, types.CASH) : '-' },
				{ label: 'refund_amount', value: rawData.refund ? formatFunctions.dataFormat(rawData.refund, types.CASH) : '-' },
				{ label: 'bank_number', value: rawData.bankacID ? rawData.bankacID : '-' },
				{ label: 'ipo_event_status', value: rawData.status ? status : '-' },
				{ label: 'common_reference_no', value: rawData.subscriptionID ? rawData.subscriptionID : '-' }
			];
			totalAmt = (rawData.currencyID ? rawData.currencyID : '') + ' ' + formatFunctions.dataFormat(rawData.totalAmount, types.CASH);
		}
	}

	return {
		allotment: allotment,
		totalAmt: totalAmt
	}
}


function mapApplyData(rawData, priceRowData, resultData) {
	const { clientID, tradingAccountID } = store.getState().trade.currentTradingAccount
	const tradingAccountName = store.getState().auth.user.external.fullname
	let totalAmt = 0;
	let detailData = [], priceData = [], previewData = [], lotSpreadList = [], stepsData = [], resultResData = [], lendingPercentList = [], marginLotSpreadList = [];
	let customSymbol = '-', customSymbol2 = '-', offPrice = '-', endDateTime = '- -', endOnlineDate = '- -';
	if (rawData.marketID && rawData.instrumentID) {
		customSymbol = `${rawData.marketID}.${rawData.instrumentID}`;
	}
	if (rawData.marketID && rawData.instrumentID && rawData.instrumentShortname) {
		customSymbol2 = `${rawData.marketID}.${rawData.instrumentID} ${rawData.instrumentShortname}`;
	}
	if (rawData.minOfferPrice && rawData.maxOfferPrice) {
		offPrice = `${utilsFunction.currencyFormatter(rawData.minOfferPrice)} - ${utilsFunction.currencyFormatter(rawData.maxOfferPrice)}`
	}
	if (rawData.endDate && rawData.endTime) {
		endDateTime = `${rawData.endDate} ${rawData.endTime}`
	}
	if (rawData.eipoendDate && rawData.eipoendTime) {
		endOnlineDate = `${rawData.eipoendDate} ${rawData.eipoendTime}`
	}

	const dateFormat = (date) => {
		return date.replace(/\//g, '').replace(/^(\d{2})(\d{2})(\d{4})$/, '$3-$2-$1')
	}

	detailData = [
		{ label: 'common_symbol', value: customSymbol },
		{ label: 'common_name', value: rawData.instrumentShortname ? rawData.instrumentShortname : '-' },
		{ label: 'common_number_offer_shares', value: formatFunctions.dataFormat(rawData.numberOfferShares, types.NUMBER) },
		{ label: 'common_number_public_offer_shares', value: formatFunctions.dataFormat(rawData.numberPublicOfferShares, types.NUMBER) },
		{ label: 'common_currency', value: rawData.currencyID ? rawData.currencyID : '-' },
		{ label: 'common_offer_price', value: offPrice ? offPrice : '-' },
		{ label: 'common_lot_size', value: rawData.lotSize ? utilsFunction.currencyFormatter(rawData.lotSize, 0) : '-' },
		{ label: 'common_start_date_for_application', value: rawData.startDate ? dateFormat(rawData.startDate) : '-' },
		{ label: 'common_end_time_for_application', value: `${dateFormat(rawData.endDate)} ${rawData.endTime}` },
		{ label: 'common_allotment_date', value: rawData.allotmentDate ? dateFormat(rawData.allotmentDate) : '-' },
		{ label: 'common_end_time_for_online_application', value: `${dateFormat(rawData.eipoendDate)} ${rawData.eipoendTime}` },
		{ label: 'common_listing_date', value: rawData.listingDate ? dateFormat(rawData.listingDate) : '-' },
		{ label: 'common_listed_exchange', value: rawData.boardName ? rawData.boardName : '-' }
	]

	stepsData = [
		{ id: 0, label: 'ipo_apply_detail_start', time: dateFormat(rawData.startDate) },
		{ id: 1, label: 'ipo_apply_detail_close', time: dateFormat(rawData.endDate) },
		{ id: 2, label: 'ipo_apply_detail_result', time: dateFormat(rawData.allotmentDate) },
		{ id: 3, label: 'ipo_apply_detail_list', time: dateFormat(rawData.listingDate) }
	]

	priceData = [
		{ label: 'common_investment_account_no', value: tradingAccountID },
		{ label: 'common_investment_account_name', value: tradingAccountName ? tradingAccountName : '-' },
		{ label: 'common_symbol_name', value: customSymbol2 },
		{ label: 'common_currency', value: rawData.currencyID },
		{ label: 'common_offering_price', value: offPrice },
		{ label: 'common_lot_size', value: utilsFunction.currencyFormatter(rawData.lotSize, 0) },
	]


	lendingPercentList = rawData.lendingPercentList.map(value => {
		let obj = {};
		obj.value = value.leadingPercentage;
		obj.label = value.leadingPercentage;
		return obj
	})

	marginLotSpreadList = rawData.lotSpreadList.map(value => {
		let obj = {};
		obj.value = value.appliedQty;
		obj.label = utilsFunction.currencyFormatter(value.appliedQty, 0);
		obj.overrideAmount = value.overrideAmount;
		return obj
	})


	if (priceRowData) {
		previewData = [
			{ label: 'common_investment_account_no', value: tradingAccountID },
			{ label: 'common_investment_account_name', value: tradingAccountName ? tradingAccountName : '-' },
			{ label: 'common_symbol_name', value: customSymbol2 },
			{ label: 'common_currency', value: rawData.currencyID },
			{ label: 'common_offer_price', value: offPrice },
			{ label: 'common_lot_size', value: utilsFunction.currencyFormatter(rawData.lotSize, 0) },
			...priceRowData
		]
		for (let i = 0; i < priceRowData.length; i++) {
			const item = priceRowData[i];
			if (item.label === 'ipo_margin_apply_margin_percentage') {
				for (let j = 0; j < previewData.length; j++) {
					const data = previewData[j];
					if (data.label === 'common_lot_size') {
						previewData.splice(j, 1);
						break;
					}
				}
				break;
			}
		}
		if (resultData) {
			for (let i = 0; i < priceRowData.length; i++) {
				const item = priceRowData[i];
				if (item.label === 'common_handing_fee') {
					item.value = resultData.handlingFee
					break;
				}
			}
			let totalHandlingFee = resultData.totalHandlingFee;
			if (!totalHandlingFee) {
				totalHandlingFee = Number(resultData.handlingFee) + Number(resultData.financingFee);
			}
			resultResData = [
				{ label: 'common_investment_account_no', value: tradingAccountID },
				{ label: 'common_symbol_name', value: customSymbol2 },
				{ label: 'common_currency', value: rawData.currencyID ? rawData.currencyID : '-' },
				{ label: 'common_offer_price', value: offPrice },
				{ label: 'common_lot_size', value: utilsFunction.currencyFormatter(rawData.lotSize, 0) },
				{ label: 'common_subscription_no', value: resultData.subscriptionID ? resultData.subscriptionID : resultData.newSubscriptionID ? resultData.newSubscriptionID : '-' },
				{ label: 'common_handing_fee', value: totalHandlingFee ? formatFunctions.dataFormat(totalHandlingFee, types.CASH) : '-' },
				{ label: 'common_application_time', value: resultData.lastModifiedTime ? resultData.lastModifiedTime : '-' },
				{ label: 'common_allotment_date', value: rawData.listingDate ? dateFormat(rawData.listingDate) : '-' },
				{ label: 'common_listing_date', value: rawData.listingDate ? dateFormat(rawData.listingDate) : '-' },
				...priceRowData
			]
		}

	}


	lotSpreadList = rawData.lotSpreadList.map(item => {
		let data = {
			...item,
			value: item.appliedQty,
			label: utilsFunction.currencyFormatter(item.appliedQty, 0),
			fee: rawData.handlingFee,
			remark: rawData.remark
		}
		return data
	})
	return {
		detailData: detailData,
		stepsData: stepsData,
		priceData: priceData,
		lotSpreadList: lotSpreadList,
		previewData: previewData,
		resultData: resultResData,
		lendingPercentList: lendingPercentList,
		marginLotSpreadList: marginLotSpreadList
	}
}

function mapModifyIpoData(rawData) {
	let modifyIpoData = [
		{ label: 'applied_qty', value: rawData.appliedQty ? formatFunctions.dataFormat(rawData.appliedQty, types.NUMBER) : '-' },
		{ label: 'margin_percentage', value: rawData.marginFinancingType !== 'Z' ? rawData.lendingPercentage ? rawData.lendingPercentage : '-' : '-' },
	]
	return {
		modifyIpoData: modifyIpoData
	}
}

function mapMarginApplyData(rawData) {
	const { tradingAccountName, clientID, tradingAccountID } = store.getState().trade.currentTradingAccount;
	let marginTopData = [];
	let customSymbol = '-', offPrice = '-'

	if (rawData.marketID && rawData.instrumentID && rawData.instrumentShortname) {
		customSymbol = `${rawData.marketID}.${rawData.instrumentID} ${rawData.instrumentShortname}`;
	}

	if (rawData.minOfferPrice && rawData.maxOfferPrice) {
		offPrice = `${utilsFunction.currencyFormatter(rawData.minOfferPrice)} - ${utilsFunction.currencyFormatter(rawData.maxOfferPrice)}`
	}

	marginTopData = [
		{ label: 'common_investment_account_no', value: tradingAccountID },
		{ label: 'common_symbol_name', value: customSymbol },
		{ label: 'common_currency', value: rawData.currencyID },
		{ label: 'common_offering_price', value: offPrice }
	]

	return marginTopData
}

function mapCAReply(rawData = {}) {
	let caReplyLeftData = [], caReplyRightData = [], caConfirmLeftData = [], caConfirmRightData = [], caResultLeftData = [], caResultRightData = [];
	let customSymbol = '-'
	let subscription = rawData.subscription || {};

	if (rawData && rawData.marketID && rawData.instrumentID) {
		customSymbol = `${rawData.marketID}.${rawData.instrumentID}`;
	}

	caReplyLeftData = [
		{ label: 'common_market', value: rawData.marketID ? rawData.marketID : '-' },
		{ label: 'common_stock_code', value: rawData.instrumentID ? rawData.instrumentID : '-' },
		{ label: 'common_stock_name', value: rawData.instrumentShortName ? rawData.instrumentShortName : '-' },
		{ label: 'common_event', value: rawData.eventID ? rawData.eventID : '-' },
		{ label: 'ca_book_close_date', value: rawData.bookClosedate ? rawData.bookClosedate : '-' },
		{ label: 'ca_issue_instrument_id', value: rawData.issueInstrumentID ? rawData.issueInstrumentID : '-' },
		{ label: 'ca_issue_instrument_name', value: rawData.issueInstrumentShortName ? rawData.issueInstrumentShortName : '-' },
	]
	caReplyRightData = [
		{ label: 'ca_book_close_qty', value: rawData.bookCloseQty ? rawData.bookCloseQty : '-' },
		{ label: 'common_offer_price', value: rawData.offerContent ? rawData.offerContent : '-' },
		{ label: 'ca_exercisable_qty', value: rawData.exercisableQty ? rawData.exercisableQty : '-' },
		{ label: 'ca_expiry_date', value: rawData.expiryDate ? rawData.expiryDate : '-' },
		{ label: 'ca_final_trade_date', value: rawData.finalTradedate ? rawData.finalTradedate : '-' },
		{ label: 'ca_channel_cut_off_time', value: rawData.channelCutofftime ? rawData.channelCutofftime : '-' },
		{ label: 'common_remark', value: rawData.webRemark ? rawData.webRemark : '-' },
	]
	caConfirmLeftData = [
		{ label: 'common_market', value: customSymbol },
		{ label: 'common_stock_code', value: rawData.instrumentID ? rawData.instrumentID : '-' },
		{ label: 'common_stock_name', value: rawData.instrumentName ? rawData.instrumentName : '-' },
		{ label: 'common_event', value: rawData.eventID ? rawData.eventID : '-' },
		{ label: 'ca_book_close_date', value: rawData.bookClosedate ? rawData.bookClosedate : '-' },
		{ label: 'ca_issue_instrument_id', value: rawData.issueInstrumentID ? rawData.issueInstrumentID : '-' },
		{ label: 'ca_issue_instrument_name', value: rawData.issueInstrumentShortName ? rawData.issueInstrumentShortName : '-' },
		{ label: 'common_offer_price', value: rawData.offerContent ? rawData.offerContent : '-' },
		{ label: 'ca_exercisable_qty', value: rawData.exercisableQty ? rawData.exercisableQty : '-' },
		{ label: 'ca_expiry_date', value: rawData.expiryDate ? rawData.expiryDate : '-' }
	]
	caConfirmRightData = [
		{ label: 'ca_final_trade_date', value: rawData.finalTradedate ? rawData.finalTradedate : '-' },
		{ label: 'ca_channel_cut_off_time', value: rawData.channelCutofftime ? rawData.channelCutofftime : '-' },
		{ label: 'ca_exercise_qty', value: rawData.exercisableQty ? rawData.exercisableQty : '-' },
		{ label: 'ca_excess_quantity', value: subscription.excessQty ? subscription.excessQty : '-' },
		{ label: 'ca_book_close_qty', value: rawData.bookCloseQty ? rawData.bookCloseQty : '-' },
		{ label: 'ca_dividend_delivery', value: rawData.dividendDelivery ? rawData.dividendDelivery : '-' },
		{ label: 'ca_reinvest_quantity', value: subscription.reinvestQty ? subscription.reinvestQty : '-' },
		{ label: 'common_handing_fee', value: subscription.handlingFee ? subscription.handlingFee : '-' },
		{ label: 'ca_application_amount', value: subscription.applicationAmount ? subscription.applicationAmount : '-' },
		{ label: 'common_remark', value: rawData.webRemark ? rawData.webRemark : '-' },
	]

	caResultLeftData = [
		{ label: 'common_market', value: customSymbol },
		{ label: 'common_stock_code', value: rawData.instrumentID ? rawData.instrumentID : '-' },
		{ label: 'common_stock_name', value: rawData.instrumentName ? rawData.instrumentName : '-' },
		{ label: 'common_event', value: rawData.eventID ? rawData.instrumentID : '-' },
		{ label: 'ca_book_close_date', value: rawData.bookClosedate ? rawData.instrumentID : '-' },
		{ label: 'ca_issue_instrument_id', value: rawData.issueInstrumentID ? rawData.instrumentID : '-' },
		{ label: 'ca_issue_instrument_name', value: rawData.issueInstrumentShortName ? rawData.instrumentID : '-' },
		{ label: 'common_offer_price', value: rawData.offerContent ? rawData.instrumentID : '-' },
		{ label: 'ca_exercisable_qty', value: rawData.exercisableQty ? rawData.instrumentID : '-' },
	]


	caResultRightData = [
		{ label: 'ca_final_trade_date', value: rawData.finalTradedate ? rawData.finalTradedate : '-' },
		{ label: 'ca_channel_cut_off_time', value: rawData.channelCutofftime ? rawData.channelCutofftime : '-' },
		{ label: 'ca_book_close_qty', value: rawData.bookCloseQty ? rawData.bookCloseQty : '-' },
		{ label: 'ca_dividend_delivery', value: rawData.dividendDelivery ? rawData.dividendDelivery : '-' },
		{ label: 'ca_reinvest_quantity', value: subscription.reinvestQty ? subscription.reinvestQty : '-' },
		{ label: 'common_handing_fee', value: subscription.handlingFee ? subscription.handlingFee : '-' },
		{ label: 'ca_application_amount', value: subscription.applicationAmount ? subscription.applicationAmount : '-' },
		{ label: 'common_remark', value: rawData.webRemark ? rawData.webRemark : '-' },
		{ label: 'ca_last_update_time', value: subscription.transactionTime ? subscription.transactionTime : '-' },
	]

	return {
		caReplyLeftData: caReplyLeftData,
		caReplyRightData: caReplyRightData,
		caConfirmLeftData: caConfirmLeftData,
		caConfirmRightData: caConfirmRightData,
		caResultLeftData: caResultLeftData,
		caResultRightData: caResultRightData
	}
}

function mapAssetAllocation(rawData) {
	let assetAllocation = {};

	assetAllocation = {
		ccy: rawData.currencyID ? rawData.currencyID : '-',
		value: rawData.totalAsset ? formatFunctions.dataFormat(rawData.totalAsset, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
		marketValue: rawData.marketValue ? formatFunctions.dataFormat(rawData.marketValue, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
		buyingPower: rawData.buyingPower ? formatFunctions.dataFormat(rawData.buyingPower, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
		holdAmount: rawData.holdAmount ? formatFunctions.dataFormat(rawData.holdAmount, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
		marginValue: rawData.marginValue ? formatFunctions.dataFormat(rawData.marginValue, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
		todayConfirmBuy: rawData.todayConfirmBuy ? formatFunctions.dataFormat(rawData.todayConfirmBuy, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
		pendingBal: rawData.pendingBalance ? formatFunctions.dataFormat(rawData.pendingBalance, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
		withdrawableBal: rawData.withdrawableBalance ? formatFunctions.dataFormat(rawData.withdrawableBalance, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
		settledBalance: rawData.settledBalance ? formatFunctions.dataFormat(rawData.settledBalance, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
		ledgerBal: rawData.ledgerBalance ? formatFunctions.dataFormat(rawData.ledgerBalance, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
		todayConfirmSell: rawData.todayConfirmSell ? formatFunctions.dataFormat(rawData.todayConfirmSell, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
		todayDelayedProfitAndLoss: rawData.todayDelayedProfitAndLoss ? formatFunctions.dataFormat(rawData.todayDelayedProfitAndLoss, types.CASH) : '-',
	}

	return assetAllocation;
}

function mapAccountPL(rawData) {
	let accountPL = {};

	accountPL = {
		floatingPL: rawData.totalFloatingPL ? formatFunctions.dataFormat(rawData.totalFloatingPL, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
		floatingPLPercent: rawData.totalFloatingPLPercent ? formatFunctions.dataFormat(rawData.totalFloatingPLPercent, types.PERCENT) : formatFunctions.dataFormat(0, types.PERCENT)
	}

	return accountPL;
}

function mapAccountAsset(rawData) {
	let leftAsset = [], middleAsset = [], rightAsset = [], SCBLeftAsset = [], SCBRightAsset = [], TTLLeftAsset = [], TTLRightAsset = [];

	leftAsset = [
		{ label: 'current_account_market_value', value: rawData.marketValue ? formatFunctions.dataFormat(rawData.marketValue, types.CASH) : '-', textColor: '#1996E3' },
		{ label: 'current_account_hold_amount', value: rawData.holdAmount ? formatFunctions.dataFormat(rawData.holdAmount, types.CASH) : '-', textColor: '#FFAD4D' },
		{ label: 'current_account_margin_Value', value: rawData.marginValue ? formatFunctions.dataFormat(rawData.marginValue, types.CASH) : '-', textColor: '' },
	]

	middleAsset = [
		{ label: 'current_account_pending_balance', value: rawData.pendingBalance ? formatFunctions.dataFormat(rawData.pendingBalance, types.CASH) : '-' },
		{ label: 'current_account_today_confirm_buy', value: rawData.todayConfirmBuy ? formatFunctions.dataFormat(rawData.todayConfirmBuy, types.CASH) : '-', textColor: '' },
		{ label: 'current_account_today_confirm_sell', value: rawData.todayConfirmSell ? formatFunctions.dataFormat(rawData.todayConfirmSell, types.CASH) : '-' },

	]

	rightAsset = [
		// { label: 'current_account_withdrawable_balance', value: rawData.withdrawableBalance ? formatFunctions.dataFormat(rawData.withdrawableBalance, types.CASH) : '-' },
		{ label: 'current_account_buying_power', value: rawData.buyingPower ? formatFunctions.dataFormat(rawData.buyingPower, types.CASH) : '-' },
		{ label: 'current_account_settled_balance', value: rawData.settledBalance ? formatFunctions.dataFormat(rawData.settledBalance, types.CASH) : '-' },
		{ label: 'current_account_ledger_balance', value: rawData.ledgerBalance ? formatFunctions.dataFormat(rawData.ledgerBalance, types.CASH) : '-' },
	]

	SCBLeftAsset = [
		{ label: 'current_account_pending_settlement', value: utilsFunction.isNull(rawData.pendingSettlement) ? formatFunctions.dataFormat(rawData.pendingSettlement, types.CURRENCY) : '-' },
		{ label: 'current_account_today_confirm_buy', value: utilsFunction.isNull(rawData.todayConfirmBuy) ? formatFunctions.dataFormat(rawData.todayConfirmBuy, types.CURRENCY) : '-' },
		{ label: 'current_account_today_confirm_sell', value: utilsFunction.isNull(rawData.todayConfirmSell) ? formatFunctions.dataFormat(rawData.todayConfirmSell, types.CURRENCY) : '-' },
	]

	SCBRightAsset = [
		{ label: 'current_account_outstanding_buy_order', value: utilsFunction.isNull(rawData.osbuyAmt) ? formatFunctions.dataFormat(rawData.osbuyAmt, types.CURRENCY) : '-' },
		{ label: 'current_account_market_Value_of_physical_stock_sales', value: utilsFunction.isNull(rawData.shortSellValueF) ? formatFunctions.dataFormat(rawData.shortSellValueF, types.CURRENCY) : '-' },
		{ label: 'current_account_total_purchasing_power', value: utilsFunction.isNull(rawData.usable) ? formatFunctions.dataFormat(rawData.usable, types.CURRENCY) : '-' },
	]

	TTLLeftAsset = [
		{ label: 'current_account_buying_power', value: rawData.buyingPower ? formatFunctions.dataFormat(rawData.buyingPower, types.CASH) : '-' },
		{ label: 'current_account_market_value', value: rawData.marketValue ? formatFunctions.dataFormat(rawData.marketValue, types.CASH) : '-', textColor: '#1996E3' },
		{ label: 'current_account_hold_amount', value: rawData.holdAmount ? formatFunctions.dataFormat(rawData.holdAmount, types.CASH) : '-', textColor: '#FFAD4D' },
		{ label: 'current_account_margin_Value', value: rawData.marginValue ? formatFunctions.dataFormat(rawData.marginValue, types.CASH) : '-', textColor: '' }
	]

	TTLRightAsset = [
		{ label: 'current_account_withdrawable_balance', value: rawData.withdrawableBalance ? formatFunctions.dataFormat(rawData.withdrawableBalance, types.CASH) : '-' },
		{ label: 'current_account_pending_balance', value: rawData.pendingBalance ? formatFunctions.dataFormat(rawData.pendingBalance, types.CASH) : '-' },
		{ label: 'current_account_settled_balance', value: rawData.settledBalance ? formatFunctions.dataFormat(rawData.settledBalance, types.CASH) : '-' },
		{ label: 'current_account_ledger_balance', value: rawData.ledgerBalance ? formatFunctions.dataFormat(rawData.ledgerBalance, types.CASH) : '-' }
	]
	return {
		leftAsset,
		middleAsset,
		rightAsset,
		SCBLeftAsset,
		SCBRightAsset,
		TTLLeftAsset,
		TTLRightAsset
	}
}

function colorMapping(type, fieldValue) {
	let isPositiveValue = true;
	if (fieldValue) {
		isPositiveValue = Number(fieldValue) > 0;
	}
	switch (type) {
		case colorTypes.MARGIN:
			return {
				color: colorValue.MARGIN
			}
		case colorTypes.BUYING_POWER:
			return {
				color: colorValue.BUYING_POWER
			}
		case colorTypes.HOLD_AMOUNT:
			return {
				color: colorValue.HOLD_AMOUNT
			}
		case colorTypes.UP_DOWN:
			return {
				color: isPositiveValue ? colorValue.UP : colorValue.DOWN
			}
		default: break;
	}
}

function mappingWebSocketMarket(market) {
	switch (market) {
		case "HKEX": return "HK";
		case "MAMK": return "SH";
		case "SZMK": return "SZ";
		case "USEX": return "XNYS";
		default: return market;
	}
}

function mappingWebSocketLanguage(lang) {
	switch (lang) {
		case "ZH_CN": return "sc";
		case "zh_TW": return "tc";
		case "en_US": return "en";
		default: return '';
	}
}

function mappingWinVestLanguage(lang) {
	switch (lang) {
		case "zh_CN": return "zh-hans";
		case "zh_TW": return "zh-hant";
		case "en_US": return "en";
		case "zh-hans": return "hans";
		case "zh-hant": return "hant";
		default: return lang;
	}
}

function mappingWinVestChartLanguage(lang) {
	switch (lang) {
		case 'zh-cn': return 'zh-Hans';
		case 'zh-hk': return 'zh-Hant';
		case 'en-us': return 'en';
		case 'vi': return 'vi';
	}
}

function computeQuoteData(quote) {
	if (!quote.last || !quote.prev) {
		return {
			last: quote.last && formatFunctions.dataFormat(quote.last, dataType.CURRENCY) || '-',
			changeValue: '-',
			changePercent: '(-)',
			classStyle: 'default-color'
		}
	}

	let change = quote.last - quote.prev;
	const positiveSign = change > 0 ? '+' : '';
	const classStyle = change > 0 ? 'rise-color' : (change < 0 ? 'fall-color' : 'default-color');
	let changePer = (change / quote.prev) * 100;
	change = formatFunctions.dataFormat(change, dataType.CURRENCY);
	changePer = formatFunctions.dataFormat(changePer, dataType.CURRENCY);
	const quoteData = {
		last: formatFunctions.dataFormat(quote.last, dataType.CURRENCY),
		changeValue: `${positiveSign}${change}`,
		changePercent: `(${positiveSign}${changePer}%)`,
		classStyle
	};
	return quoteData;
}

function mappingMDSMarketToStock(market) {
	switch (market) {
		case "HK": return "HKEX";
		case "MA": return "MAMK";
		case "SZ": return "SZMK";
		case "US": return "USEX";
		default: return market;
	}
}

function mappingMDSMarketToStock_SH(market) {
	switch (market) {
		case "HK": return "HKEX";
		case "SH": return "MAMK";
		case "SZ": return "SZMK";
		case "US": return "USEX";
		default: return market;
	}
}

function mappingStockCode(stockCode) {
	if (!stockCode) return;
	let stockID = stockCode.split('').findIndex(i => i !== '0')
	if (stockID > -1) {
		stockID = stockCode.substr(stockID)
	}
	return stockID;
}

function mappingStatement(data) {
	let language = store.getState().app.language;
	let statementType = '', accountType = ''
	let resultData = {}
	if (data.statementType && data.accountType) {
		switch (data.statementType) {
			case 'D': statementType = getSafe(() => language.DStatement); break;
			case 'M': statementType = getSafe(() => language.MStatement); break;
		}
		switch (data.accountType) {
			case 'C': accountType = getSafe(() => language.common_cash_account); break;
			case 'M': accountType = getSafe(() => language.common_margin_account); break;
		}
		resultData.accountType = accountType
		resultData.statementType = statementType
	}
	return resultData;
}

function numericalTransformation(num, lang) {
	if (num === '-') return num
	if (num) {
		const language = lang.lang
		let negative = ''
		if (num.includes('-')) {
			negative = '-'
			num = num.substr(1, (num.length + 1))
		} else if (num.includes(',')) {
			num = num.replace(/,/g, '')
			if (num.includes('.')) {
				num = num.split('.')[0]
			}
		}
		if (language == 'en_US') {
			if (num.length >= 10) {
				if ((num / 1000000000).toString().includes('.')) {
					return negative + (num / 1000000000).toString().split('.')[0] + '.' + (num / 1000000000).toString().split('.')[1].substr(0, 2) + 'B'
				} else {
					return negative + (num / 1000000000) + 'B'
				}
			} else if (num.length >= 7) {
				if ((num / 1000000).toString().includes('.')) {
					return negative + (num / 1000000).toString().split('.')[0] + '.' + (num / 1000000).toString().split('.')[1].substr(0, 2) + 'M'
				} else {
					return negative + (num / 1000000) + 'M'
				}
			} else return num
		} else {
			if (num.length >= 9) {
				if ((num / 100000000).toString().includes('.')) {
					return negative + (num / 100000000).toString().split('.')[0] + '.' + (num / 100000000).toString().split('.')[1].substr(0, 2) + '亿'
				} else {
					return negative + (num / 100000000) + '亿'
				}
			} else if (num.length >= 5) {
				if ((num / 10000).toString().includes('.')) {
					return negative + (num / 10000).toString().split('.')[0] + '.' + (num / 10000).toString().split('.')[1].substr(0, 2) + '万'
				} else {
					return negative + (num / 10000) + '万'
				}
			} else return num
		}
	} else {
		return num
	}
}